module.exports = __webpack_public_path__ + "img/ch41.7735e0f7.jpg";